"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
const plugins_1 = require("../plugins");
const utils_1 = require("../utils");
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const browser_tracker_1 = require("@snowplow/browser-tracker");
/**
 * Creates a new Snowplow Tracker
 *
 * @param params all required and optional params for the Tracker initialization
 */
const snowplowTracker = (params) => {
    const enabledPlugins = (0, plugins_1.getEnabledPlugins)(params.pluginConfiguration);
    const trackerConfig = Object.assign(Object.assign({}, (0, lodash_merge_1.default)(constants_1.DEFAULT_TRACKER_CONFIG, params.trackerConfiguration)), { plugins: (0, plugins_1.getInitializedPlugins)(enabledPlugins) });
    const tracker = (0, browser_tracker_1.newTracker)(constants_1.SNOWPLOW_TRACKER_NAME, params.collectorUrl, Object.assign({ appId: params.appId }, trackerConfig));
    if (typeof window !== 'undefined' &&
        window.snowplow === undefined &&
        tracker !== null &&
        tracker !== undefined) {
        window.snowplow = tracker;
    }
    if (typeof window !== 'undefined' && window.snowplow !== undefined) {
        (0, plugins_1.enablePlugins)(enabledPlugins);
        (0, browser_tracker_1.clearGlobalContexts)();
        (0, utils_1.setGlobalContexts)(params.presetGlobalContexts, params.additionalGlobalContexts);
        (0, utils_1.dispatchSnowplowTrackerReadyEvent)();
    }
    else {
        (0, utils_1.dispatchSnowplowTrackerNotReadyEvent)();
    }
    return tracker;
};
exports.default = snowplowTracker;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic25vd3Bsb3dUcmFja2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3RyYWNrZXIvc25vd3Bsb3dUcmFja2VyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsMkNBQTRFO0FBQzVFLHdDQUFxRjtBQUNyRixvQ0FJa0I7QUFDbEIsZ0VBQWlDO0FBQ2pDLCtEQUE0RTtBQU01RTs7OztHQUlHO0FBQ0gsTUFBTSxlQUFlLEdBQUcsQ0FBQyxNQUE2QixFQUFxQyxFQUFFO0lBQ3pGLE1BQU0sY0FBYyxHQUFtQixJQUFBLDJCQUFpQixFQUFDLE1BQU0sQ0FBQyxtQkFBbUIsQ0FBQyxDQUFDO0lBQ3JGLE1BQU0sYUFBYSxtQ0FDWixJQUFBLHNCQUFLLEVBQUMsa0NBQXNCLEVBQUUsTUFBTSxDQUFDLG9CQUFvQixDQUFDLEtBQzdELE9BQU8sRUFBRSxJQUFBLCtCQUFxQixFQUFDLGNBQWMsQ0FBQyxHQUNqRCxDQUFDO0lBRUYsTUFBTSxPQUFPLEdBQUcsSUFBQSw0QkFBVSxFQUFDLGlDQUFxQixFQUFFLE1BQU0sQ0FBQyxZQUFZLGtCQUNqRSxLQUFLLEVBQUUsTUFBTSxDQUFDLEtBQUssSUFDaEIsYUFBYSxFQUNsQixDQUFDO0lBRUgsSUFDSSxPQUFPLE1BQU0sS0FBSyxXQUFXO1FBQzdCLE1BQU0sQ0FBQyxRQUFRLEtBQUssU0FBUztRQUM3QixPQUFPLEtBQUssSUFBSTtRQUNoQixPQUFPLEtBQUssU0FBUyxFQUN2QjtRQUNFLE1BQU0sQ0FBQyxRQUFRLEdBQUcsT0FBTyxDQUFDO0tBQzdCO0lBRUQsSUFBSSxPQUFPLE1BQU0sS0FBSyxXQUFXLElBQUksTUFBTSxDQUFDLFFBQVEsS0FBSyxTQUFTLEVBQUU7UUFDaEUsSUFBQSx1QkFBYSxFQUFDLGNBQWMsQ0FBQyxDQUFDO1FBQzlCLElBQUEscUNBQW1CLEdBQUUsQ0FBQztRQUN0QixJQUFBLHlCQUFpQixFQUFDLE1BQU0sQ0FBQyxvQkFBb0IsRUFBRSxNQUFNLENBQUMsd0JBQXdCLENBQUMsQ0FBQztRQUNoRixJQUFBLHlDQUFpQyxHQUFFLENBQUM7S0FDdkM7U0FBTTtRQUNILElBQUEsNENBQW9DLEdBQUUsQ0FBQztLQUMxQztJQUVELE9BQU8sT0FBTyxDQUFDO0FBQ25CLENBQUMsQ0FBQztBQUVGLGtCQUFlLGVBQWUsQ0FBQyJ9


// WEBPACK FOOTER //
// ../../../src/tracker/snowplowTracker.ts